import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';
import Tooltip from '@mui/material/Tooltip';
import Typography from '@mui/material/Typography';
import { HighlightedPhrase } from '@openx/components-core/lib/HighlightedPhrase/HighlightedPhrase';
import type { ReactNode } from 'react';
import { PredefinedChipIcon } from '../../../icons/PredefinedChipIcon';

export type BaseSegmentHeaderProps = {
  name: string;
  isLAL: boolean;
  showPredefinedSegmentBadge?: boolean;
  searchPhrase?: string;
  config: {
    leftIcon: React.ReactNode;
    onClick?: () => void;
  };
  isSelectedItem?: boolean;
  isSeedAggregate?: boolean;
  expirationAlert?: ReactNode;
};

export const SegmentHeader = ({
  name,
  isLAL,
  searchPhrase,
  config: { leftIcon, onClick },
  isSelectedItem,
  isSeedAggregate,
  showPredefinedSegmentBadge = false,
  expirationAlert,
}: BaseSegmentHeaderProps) => {
  const showLeftIcon = (isLAL && isSelectedItem && !isSeedAggregate) || !isLAL;

  return (
    <Stack
      direction="row"
      onClick={onClick}
      data-test="segment-header"
      sx={{
        maxWidth: '100%',
        alignItems: 'center',
        cursor: onClick ? 'pointer' : 'default',
      }}
    >
      {showLeftIcon && leftIcon}
      <Box
        component="div"
        sx={{
          ml: leftIcon ? 1 : 0,
          display: 'flex',
          gap: 1,
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        {showPredefinedSegmentBadge && (
          <Box sx={{ minWidth: 'fit-content', display: 'inline-flex' }} role="img" aria-label="Predefined segment">
            <PredefinedChipIcon />
          </Box>
        )}
        <Tooltip title={name} placement="top" enterDelay={500}>
          <Typography
            variant="body1Bold"
            component="span"
            sx={{ display: 'block', overflow: 'hidden', textOverflow: 'ellipsis', whiteSpace: 'nowrap' }}
          >
            {searchPhrase ? <HighlightedPhrase searchPhrase={searchPhrase}>{name}</HighlightedPhrase> : name}
          </Typography>
        </Tooltip>
        {expirationAlert}
      </Box>
    </Stack>
  );
};
